
import { computed, defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';
import { IPhoto } from '@/types/interfaces';
import { PHOTO_VIEW_TYPE } from '@/types/enums';

export default defineComponent({
  name: 'SpacesGroupDesc',
  props: {
    data: {
      type: Object,
      required: true,
    },
    recommended: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const router = useRouter();

    const userData = computed(() => ({
      name: props.data.name,
      info: props.data.groupInfo,
      members: props.data.members,
      photo: props.data.photo,
    }));

    /* eslint-disable global-require */
    const memberIcon = computed(() => require('@/assets/img/icons-img/user.svg'));
    /* eslint-enable global-require */
    const groupImg = computed(() => {
      if (userData.value.photo?.url) {
        return lowResUrlByViewTypeByUrl(userData.value.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      /* eslint-disable global-require */
      return require('@/assets/img/icons-img/group-img.svg');
      /* eslint-enable global-require */
    });

    function onGroupClick() {
      router.push(`/spaces/groups/group/${props.data.id}`);
    }

    function getMemberPhoto(photo: IPhoto | undefined) {
      return photo ? lowResUrlByViewTypeByUrl(photo.url, PHOTO_VIEW_TYPE.WHSML) : memberIcon.value;
    }

    return {
      userData,
      groupImg,
      memberIcon,
      onGroupClick,
      getMemberPhoto,
    };
  },
});
